import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import PenCode from '../../components/PenCode';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <center>
    <img src="/public/assets/images/cf.png" alt="CleverForm Logo" style={{
        maxWidth: '100%',
        height: '40vh'
      }} />
    <h1 style={{
        textAlign: 'center',
        color: '#132857',
        fontSize: '7vh'
      }}>CleverForm.js</h1>
    
    <h3 style={{
        color: '#747272'
      }}>An elegant💕 form validation library for JavaScript</h3>
    <h3 style={{
        color: '#747272'
      }}>Fast and easy way to implement form validation in HTML Form</h3>
    <h2 style={{
        color: 'orange'
      }}>Zero dependencies</h2>
    
    
    
    </center>
    <hr></hr>
    <h3 {...{
      "id": "have-a-try-"
    }}>{`Have a try !`}</h3>
    <p>{`Below is the simplest example of form validation. `}</p>
    <p>{`With a few lines of codes, you can implement form validation elegantly.`}</p>
    <PenCode penID="gOrrYmX" height="620" mdxType="PenCode" />
    <br />
Go to the example section for more examples.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      